import React from 'react';

interface SidebarShimmerProps {
  items?: number;
  className?: string;
}

const SidebarShimmer: React.FC<SidebarShimmerProps> = ({ 
  items = 8,
  className = ''
}) => {
  return (
    <div className={`sidebar-shimmer ${className}`}>
      {Array.from({ length: items }).map((_, index) => (
        <div key={index} className="sidebar-item-shimmer">
          <div
            className="shimmer-loader"
            style={{
              width: '20px',
              height: '20px',
              borderRadius: '4px',
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.5s infinite',
              marginRight: '12px'
            }}
          />
          <div
            className="shimmer-loader"
            style={{
              flex: 1,
              height: '16px',
              borderRadius: '4px',
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.5s infinite'
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default SidebarShimmer; 